<template>
	<div>
		<div class="home-sider">
			<div class="home-job-menu">
				<div class="job-menu-wrapper">
					<dl v-for="(item,index) in newData" :key="index" @mouseover="changeMask(index,true)"
						@mouseout="changeMask(index,false)">
						<dd>
							<i class="el-icon-caret-right"></i>
							<b>{{item.name}}</b>
							<a href="javascript:void(0);" v-if="item.children[0]">{{item.children[0]? item.children[0].name:''}}</a>
							<a href="javascript:void(0);" v-if="item.children[1]">{{item.children[1]? item.children[1].name:''}}</a>
							<a href="javascript:void(0);" v-if="item.children[2]">{{item.children[2]? item.children[2].name:''}}</a>
							<a href="javascript:void(0);" v-if="item.children[3]">{{item.children[3]? item.children[3].name:''}}</a>
						</dd>
						<div class="menu-sub" :ref="'mask' + index" @mouseover="changeMask(index,true)"
							@mouseout="changeMask(index,false)">
							<div class="text">
								<a href="javascript:void(0);" v-for="(item2,index2) in item.children"
									:key="index2">{{item2.name}}</a>
							</div>
						</div>
					</dl>
				</div>
				<div class="job-menu-page">
					<span class="menu-page-info"><em class="menu-current-page">{{currentPage+1}}</em> / {{pageNum()}}</span>
					<div class="menu-page-controller">
						<span class="menu-page-btn menu-page-prev" @click="prePage()"><i
								class="el-icon-caret-left"></i></span>
						<span class="menu-page-btn menu-page-next" @click="nextPage()"><i
								class="el-icon-caret-right"></i></span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Cascader',
		data() {
			return {
				newData: [],
				allData:[],
				pageSize: 7,
				currentPage: 0
			}
		},
		methods: {
			setData(data) {
				this.newData = data
				this.allData = data
				this.setPageData()
			},
			nextPage() {
				if (this.currentPage == this.pageNum - 1) return;
				this.currentPage++;
				this.setPageData()
			},
			prePage() {
				if (this.currentPage == 0) return;
				this.currentPage--;
				this.setPageData()
			},
			pageNum() {
				return Math.ceil(this.allData.length / this.pageSize) || 1;
			},
			setPageData() {
				let start = this.currentPage * this.pageSize;
				let end = Math.min((this.currentPage + 1) * this.pageSize, this.allData.length)
				this.newData = this.allData.slice(start, end)
			},
			changeMask(index, isIN) {
				let vm = this;
				let mask = vm.$refs['mask' + index];
				if (isIN) {
					mask[0].style.display = 'block';
				} else {
					mask[0].style.display = 'none';
				}
				// if (mask[0].style.display == 'none') {
				// 	mask[0].style.display = 'block';
				// } else {
				// 	mask[0].style.display = 'none';
				// }
			}
		}
	}
</script>

<style scoped>
	.home-job-menu {
		color: #666;
		position: relative;
		z-index: 1002;
		background: #fff;
		border-radius: 12px;
		padding: 6px 0 0 0;
	}

	.home-job-menu .job-menu-wrapper {
		height: 289px;
		padding: 0 3px;
		overflow: hidden;
	}

	.home-job-menu dl {
		height: 22px;
		transition: all .2s linear;
		border-radius: 8px;
		padding: 9px 10px;
		margin: 0px;
	}

	.home-job-menu dl:hover {
		box-shadow: 0 4px 16px 0 rgba(153, 153, 153, .2);
	}

	.home-job-menu dd {
		position: relative;
		height: 22px;
		line-height: 22px;
		overflow: hidden;
		margin-left: 20px;
	}

	.home-job-menu dd i {
		float: right;
	}

	.home-job-menu dd b {
		float: left;
		font-size: 16px;
		font-weight: 500;
		color: #222;
		line-height: 22px;
	}

	.home-job-menu a:hover {
		color: #00a6a7;
		font-weight: 500;
	}

	.home-job-menu .menu-sub .text a:hover {
		color: #00a6a7;
		font-weight: 500;
	}

	.home-job-menu a {
		display: inline-block;
		font-size: 14px;
		font-weight: 400;
		color: #666;
		height: 22px;
		line-height: 22px;
		margin-left: 20px;
	}

	.home-job-menu .menu-sub {
		display: none;
		position: absolute;
		top: 0;
		left: 101%;
		padding: 16px 8px 10px 16px;
		margin-top: 0;
		width: 100%;
		height: 314px;
		overflow: overlay;
		overflow: auto;
		z-index: 1;
		background: #fff;
		box-shadow: 0 10px 40px 0 rgba(153, 153, 153, .2);
		border-radius: 12px;
		border: 1px solid #ebeef5;
	}

	.home-job-menu .menu-sub .text {
		border-bottom: solid 1px #f0f3fa;
		padding: 6px 0;
	}

	.home-job-menu .menu-sub .text a {
		margin-left: 0;
		margin-right: 20px;
		margin-bottom: 6px;
		margin-top: 6px;
		color: #222;
		font-size: 13px;
		height: 18px;
		line-height: 18px;
	}

	.home-job-menu a {
		display: inline-block;
		font-size: 14px;
		font-weight: 400;
		color: #666;
		height: 22px;
		line-height: 22px;
		margin-left: 20px;
	}

	.home-job-menu .job-menu-page {
		position: relative;
		height: 44px;
		padding: 0 20px;
		border-top: 1px dashed #e6e6e6;
		overflow: hidden;
	}

	.home-job-menu .menu-page-info {
		float: left;
		font-size: 14px;
		font-weight: 500;
		color: #00a6a7;
		line-height: 20px;
		margin-top: 12px;
	}

	.home-job-menu .menu-page-controller {
		float: right;
		margin-top: 10px;
	}

	.home-job-menu .menu-page-btn {
		float: left;
		width: 24px;
		height: 24px;
		background: rgba(0, 190, 189, .1);
		border-radius: 6px;
		color: #00bebd;
		transition: all .2s linear;
		margin-left: 12px;
		text-align: center;
		line-height: 24px;
		cursor: pointer;
	}
</style>
